import { useErrorBoundary } from 'react-error-boundary';
export const useErrorHandler = (error) => {
    const { showBoundary } = useErrorBoundary();
    if (error) {
        showBoundary(error);
    }
};
